import { render, staticRenderFns } from "./ModalConfirmShareInformation.vue?vue&type=template&id=3a65e6ee&scoped=true"
import script from "./ModalConfirmShareInformation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmShareInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65e6ee",
  null
  
)

export default component.exports